import { render, staticRenderFns } from "./goodDetail.vue?vue&type=template&id=471792e4&scoped=true"
import script from "./goodDetail.vue?vue&type=script&lang=js"
export * from "./goodDetail.vue?vue&type=script&lang=js"
import style0 from "./goodDetail.vue?vue&type=style&index=0&id=471792e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471792e4",
  null
  
)

export default component.exports